module.exports = (obj) => {
    if (typeof obj == 'object' && obj !== null) {

        if (typeof Object.getPrototypeOf == 'function') {
            const proto = Object.getPrototypeOf(obj)
            return proto === Object.prototype || proto === null
        }

        return Object.prototype.toString.call(obj) === '[object Object]'
    }

    return false
}